import { render, staticRenderFns } from "./ProductOne.vue?vue&type=template&id=81516176&"
import script from "./ProductOne.vue?vue&type=script&lang=js&"
export * from "./ProductOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81516176')) {
      api.createRecord('81516176', component.options)
    } else {
      api.reload('81516176', component.options)
    }
    module.hot.accept("./ProductOne.vue?vue&type=template&id=81516176&", function () {
      api.rerender('81516176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductOne.vue"
export default component.exports